import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AIResponseSave, PlatformSource, RecentAnswer } from "winslow-core";
import { selectUser } from "../../redux/features/appData";
import { apiGetWorkspaceAnswers } from "../../services/AIService";
import { getDateDaysAgo } from "winslow-core";
import "./CollectionStats.css";
// import { apiGetCollectionQuestionCountForUserInWorkspace } from "../../services/CollectionService";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Box, Tab } from "@mui/material";
import { CollectionStatsQuestions } from "./CollectionStatsQuestions";
import TabPanel from "@mui/lab/TabPanel";
import { CategoriesChart } from "./CategoriesChart";
import {
  apiDashboardGetCategoryResponsesForCollection,
  apiDashboardGetThemeResponsesForCollection,
} from "../../services/DashboardService";
import { DashboardThemeResponse } from "winslow-core";
import { SummaryChart } from "./SummaryChart";
import RatingStats from "./RatingStats";
import { NameSelector } from "../NameSelector/NameSelector";
import { CategorySelector } from "./CategorySelector";

// import { CollectionResourcesZero } from "../collections/CollectionResourcesZero";
import { AnswerSidebar } from "../collections/HomeScreen/AnswerSidebar";
import { ViewToggle } from "./ViewToggle";
import { SourceSelector } from "../SourceSelector";
import { AskedQuestionsZero } from "../collections/AskedQuestionsZero";

const TAB_NUMBERS = {
  DASHBOARD: "1",
  CATEGORIES: "2",
  THEMES: "3",
  RATINGS: "4",
};

export const CollectionStats = () => {
  const { collectionId } = useParams();

  const storeUser = useSelector(selectUser);
  // const collections = useSelector(selectCollections);

  const [tabNumber, setTabNumber] = useState(TAB_NUMBERS.DASHBOARD);

  // const [collectionQuestionCount, setCollectionQuestionCount] = useState<
  //   CollectionQuestionCount[] | null
  // >(null);
  // const [userCount, setUserCount] = useState<number | null>(null);

  const [categoryResponses, setCategoryResponses] = useState<
    AIResponseSave[] | null
  >(null);
  const [themeResponses, setThemeResponses] = useState<
    DashboardThemeResponse[] | null
  >(null);
  const [nameFilter, setNameFilter] = useState<string | undefined>(undefined);
  const [sourceFilter, setSourceFilter] = useState<PlatformSource | undefined>(
    undefined
  );
  const [categoryFilter, setCategoryFilter] = useState<string | undefined>(
    undefined
  );
  // ratings-specific state moved to RatingsTab

  const [answers, setAnsers] = useState<RecentAnswer[] | null>(null);
  // const [ratingAnswers, setRatingAnswers] = useState<RecentAnswer[] | null>(null);

  const [view, setView] = useState<"cards" | "list" | "list">("cards");

  const loadData = async () => {
    (async () => {
      if (storeUser && collectionId && storeUser.currentWorkspaceId) {
        const answersResult = await apiGetWorkspaceAnswers(
          storeUser.currentWorkspaceId,
          storeUser.id
        );
        if (answersResult) {
          setAnsers(answersResult);
        }
        // const cqc = await apiGetCollectionQuestionCountForUserInWorkspace(
        //   storeUser.currentWorkspaceId,
        //   storeUser.id
        // );
        // setCollectionQuestionCount(cqc);

        // category questions
        const payload = {
          greaterThan: getDateDaysAgo(30),
          lessThan: new Date(),
        };

        const catQuestions =
          await apiDashboardGetCategoryResponsesForCollection(
            collectionId,
            payload
          );

        if (catQuestions) {
          setCategoryResponses(catQuestions);
        }
      }
    })();
  };

  useEffect(() => {
    if (collectionId) {
      loadData();
    }
  }, [collectionId, storeUser]);

  const handleRefresh = () => {
    loadData();
  };

  // const countUniqueEmailUsers = (responses: RecentAnswer[]) => {
  //   const users: Map<string, boolean> = new Map<string, boolean>();
  //   responses.forEach((response: RecentAnswer) => {
  //     if (response.email) {
  //       users.set(response.email, true);
  //     }
  //   });
  //   return Array.from(users.keys()).length;
  // };

  const lazyLoadThemeResponses = async () => {
    if (!themeResponses && collectionId && categoryResponses) {
      const aiResponseSaveIds = categoryResponses.map(
        (response: AIResponseSave) => {
          return response.id;
        }
      );

      const themeQuestions = await apiDashboardGetThemeResponsesForCollection({
        questionIds: aiResponseSaveIds,
      });

      if (themeQuestions) {
        setThemeResponses(themeQuestions);
      }
    }
  };

  // const getCollectionQuestionCount = (collectionId: string) => {
  //   if (!collectionQuestionCount) {
  //     return 0;
  //   }

  //   const index = collectionQuestionCount.findIndex(
  //     (cqc: CollectionQuestionCount) => {
  //       return cqc.collectionId === collectionId;
  //     }
  //   );

  //   if (index === -1) {
  //     return 0;
  //   }

  //   return collectionQuestionCount[index].count;
  // };

  // let resources = 0;
  // if (collections && collectionId) {
  //   const index = collections.findIndex((collection) => collection.id === collectionId);
  //   if (index !== -1) {
  //     resources = collections[index].linkRecords.length;
  //   }
  // }

  const changeTab = (e: any, newValue: string) => {
    setTabNumber(newValue);

    if (newValue === TAB_NUMBERS.THEMES) {
      lazyLoadThemeResponses();
    }
  };

  // const getThemeQuestions = (theme?: string) => {
  //   const responses: AIResponseSave[] = [];

  //   if (themeResponses) {
  //     themeResponses.forEach((themeResponse: DashboardThemeResponse) => {
  //       if (!theme || themeResponse.theme === theme) {
  //         responses.push(...themeResponse.aiResponses);
  //       }
  //     });
  //   }

  //   console.log("[getThemeQuestions] responses: ", responses);
  //   return responses;
  // };

  return (
    <div id="collection-stats">
      {/* <div className="page-title">
          Dashboard
      </div> */}
      <TabContext value={tabNumber}>
        <Box sx={{}}>
          <TabList
            onChange={changeTab}
            className="collection-tablist"
            style={{
              padding: 0,
            }}
            sx={{
              "&.MuiTabPanel": { padding: "0px" },
              scrollbarWidth: 0,
            }}
            TabIndicatorProps={{
              style: { background: "var(--text-color-primary)" },
            }}>
            <Tab
              sx={{
                "&.Mui-selected": {
                  color: "var(--text-color-primary)",
                },
                color: "var(--text-color-secondary)",
              }}
              label="Dashboard"
              value="1"
            />

            <Tab
              sx={{
                padding: 0,
                "&.Mui-selected": {
                  color: "var(--text-color-primary)",
                },
                color: "var(--text-color-secondary)",
              }}
              label="Categories"
              value="2"
            />

            {/* <Tab
              sx={{
                "&.Mui-selected": {
                  color: "var(--text-color-primary)",
                },
                color: "var(--text-color-secondary)",
              }}
              label="Themes"
              value="3"
            /> */}
            <Tab
              sx={{
                padding: 0,
                "&.Mui-selected": {
                  color: "var(--text-color-primary)",
                },
                color: "var(--text-color-secondary)",
              }}
              label="Ratings"
              value="4"
            />
          </TabList>
        </Box>

        <TabPanel value="1">
          <div className="collection-stats-tab">
            {answers && (
              <div className="collection-stats-summary-chart">
                <SummaryChart
                  responses={answers}
                  endDate={new Date()}
                  startDate={getDateDaysAgo(30)}
                  period={"daily"}
                />
              </div>
            )}

            {answers && answers.length > 0 && (
              <div className="collection-stats-filter">
                <NameSelector responses={answers} onChange={setNameFilter} />
                <SourceSelector
                  responses={answers}
                  onChange={setSourceFilter}
                />
                <ViewToggle view={view} setView={setView} />
              </div>
            )}

            {answers && answers.length > 0 && (
              <div className="collection-stats-feedback">
                <CollectionStatsQuestions
                  questions={answers}
                  filterName={nameFilter}
                  filterSource={sourceFilter}
                  view={view}
                />
              </div>
            )}

            {answers && answers.length === 0 && <AskedQuestionsZero />}
          </div>
        </TabPanel>

        <TabPanel value="2">
          <div className="collection-stats-tab">
            {categoryResponses && (
              <div className="collection-stats-categories-chart">
                <CategoriesChart
                  responses={categoryResponses}
                  endDate={new Date()}
                  startDate={getDateDaysAgo(30)}
                  period={"daily"}
                />
              </div>
            )}

            {answers && categoryResponses && categoryResponses.length > 0 && (
              <div className="collection-stats-filter">
                <CategorySelector
                  responses={categoryResponses}
                  onChange={setCategoryFilter}
                />
                <SourceSelector
                  responses={answers}
                  onChange={setSourceFilter}
                />
                <ViewToggle view={view} setView={setView} />
              </div>
            )}

            {answers && categoryResponses && categoryResponses.length > 0 && (
              <div className="collection-stats-feedback">
                <CollectionStatsQuestions
                  questions={answers}
                  filterName={nameFilter}
                  filterCategory={categoryFilter}
                  filterSource={sourceFilter}
                  view={view}
                />
              </div>
            )}

            {categoryResponses && categoryResponses.length === 0 && (
              <AskedQuestionsZero />
            )}
          </div>
        </TabPanel>

        {/* <TabPanel
          value="3"
          // onFocus={lazyLoadThemeResponses}
        >
          <div className="collection-stats-tab">
            {themeResponses && (
              <div className="collection-stats-themes-chart">
                <ThemesChart
                  themesData={themeResponses}
                  endDate={new Date()}
                  startDate={getDateDaysAgo(30)}
                />
              </div>
            )}

            {getThemeQuestions().length > 0 && (
              <div className="collection-stats-filter">
                <EmailSelector
                  responses={getThemeQuestions()}
                  onChange={setEmailFilter}
                />
              </div>
            )}

            <div className="collection-stats-feedback">
              <CollectionStatsQuestions
                questions={getThemeQuestions()}
                filterEmail={emailFilter}
              />
            </div>
          </div>
        </TabPanel> */}

        <TabPanel value="4">
          {answers ? (
            <RatingStats
              answers={answers.filter((a) => a.message?.feedbackRating)}
              onRatingDelete={handleRefresh}
            />
          ) : (
            <AskedQuestionsZero />
          )}
        </TabPanel>
      </TabContext>
      <AnswerSidebar />
    </div>
  );
};
